import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ArrowLeft, Edit, User, Clock } from 'lucide-react';

// Visor de documentos
const DocumentViewer = ({ document, onClose, onEdit, user }) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-gray-900/95 backdrop-blur-xl rounded-2xl w-full max-w-4xl h-[90vh] flex flex-col border border-white/20">
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <div className="flex items-center space-x-4">
            <button
              onClick={onClose}
              className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors"
            >
              <ArrowLeft className="w-5 h-5 text-white" />
            </button>
            <h2 className="text-xl font-semibold text-white">{document.title}</h2>
          </div>
          {user?.role === 'admin' && (
            <button
              onClick={() => onEdit(document)}
              className="flex items-center space-x-2 px-4 py-2 bg-purple-500/20 text-purple-300 rounded-lg hover:bg-purple-500/30 transition-all"
            >
              <Edit className="w-4 h-4" />
              <span>Editar</span>
            </button>
          )}
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <div className="mb-6 flex flex-wrap items-center gap-3 text-sm text-gray-400">
            <span className="flex items-center">
              <User className="w-4 h-4 mr-1" />
              {document.author}
            </span>
            <span>•</span>
            <span className="flex items-center">
              <Clock className="w-4 h-4 mr-1" />
              {new Date(document.lastUpdated).toLocaleDateString()}
            </span>
            {document.tags && document.tags.length > 0 && (
              <>
                <span>•</span>
                <div className="flex flex-wrap gap-2">
                  {document.tags.map(tag => (
                    <span key={tag} className="px-2 py-1 bg-purple-500/20 text-purple-300 rounded-full text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
              </>
            )}
          </div>

          <div className="prose prose-invert max-w-none">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{document.content || ''}</ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentViewer;
